/**
 * Collection Ads
 * Inserts promotional ad cards into the product grid at specified positions
 */

class CollectionAds {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.insertAds());
    } else {
      this.insertAds();
    }

    // Re-insert ads when new products are loaded (infinite scroll)
    document.addEventListener('results-list:products-loaded', () => this.insertAds());
  }

  insertAds() {
    // Find the collection ads section
    const adsSection = document.querySelector('.collection-ads-section');
    if (!adsSection) return;

    // Find the product grid
    const productGrid = document.querySelector('.product-grid');
    if (!productGrid) return;

    // Get all ad templates
    const adTemplates = adsSection.querySelectorAll('.collection-ad-template');
    if (adTemplates.length === 0) return;

    // Get existing product items
    const productItems = Array.from(productGrid.querySelectorAll('.product-grid__item:not(.product-grid__item--ad)'));

    // Remove any existing ads first (in case of re-initialization)
    productGrid.querySelectorAll('.product-grid__item--ad').forEach(ad => ad.remove());

    // Sort templates by position (in case they're not in order)
    const sortedTemplates = Array.from(adTemplates).sort((a, b) => {
      const posA = parseInt(a.dataset.position) || 0;
      const posB = parseInt(b.dataset.position) || 0;
      return posA - posB;
    });

    // Insert each ad at its specified position
    sortedTemplates.forEach(template => {
      const position = parseInt(template.dataset.position) || 0;
      const adContent = template.content.cloneNode(true);
      const adElement = adContent.querySelector('.product-grid__item--ad');

      if (!adElement) return;

      // Insert ad at the specified position
      if (position === 0) {
        // Insert at the beginning
        productGrid.insertBefore(adElement, productGrid.firstChild);
      } else if (position >= productItems.length) {
        // Insert at the end
        productGrid.appendChild(adElement);
      } else {
        // Insert after the product at position-1
        const targetProduct = productItems[position];
        if (targetProduct) {
          targetProduct.parentNode.insertBefore(adElement, targetProduct);
        } else {
          productGrid.appendChild(adElement);
        }
      }
    });

    console.log(`✅ Inserted ${sortedTemplates.length} collection ad(s) into product grid`);
  }
}

// Initialize when script loads
new CollectionAds();
